export { alertDirective } from './alert/alert-directive';
export { compareToDirective } from './compare-to-directive';
export { compileDirective } from './compile-directive';
export { dataFieldDirective } from './data-field/data-field-directive';
export { dataTableCardDirective } from './data-table/data-table-card-directive';
export { dataTableDirective } from './data-table/data-table-directive';
export { formatterCurrencyDirective } from './formatter-currency-directive';
export { formatterDurationDirective } from './formatter-duration-directive';
export { helpButtonDirective } from './help-button-directive';
export { loadingDirective } from './spinner/loading-directive';
export { paginationDirective } from './pagination/pagination-directive';
export { panelDirective } from './panel/panel-directive';
export { searchDirective } from './search/search-directive';
export { sideNavDirective } from './side-nav/side-nav-directive';
export { simpleCardDirective } from './simple-card-directive';
export { subheaderDirective } from './subheader/subheader-directive';
export { toggleButtonGroupDirective } from './toggle-button-group/toggle-button-group-directive';
export { visibleDirective } from './visible-directive';

export * from './inputs';

// Drag event handles
export const dragEventDirectives = {};

['drag', 'dragend', 'dragenter', 'dragexit', 'dragleave', 'dragover', 'dragstart', 'drop'].forEach(eventName => {
    const directiveName = 'ng' + eventName.charAt(0).toUpperCase() + eventName.slice(1);

    dragEventDirectives[directiveName] = [
        '$parse',
        function($parse) {
            return {
                restrict: 'A',
                compile: function($element, attr) {
                    const fn = $parse(attr[directiveName], null, true);

                    return function ngDragEventHandler(scope, element) {
                        element.on(eventName, function(event) {
                            const callback = function() {
                                fn(scope, { $event: event });
                            };

                            scope.$apply(callback);
                        });
                    };
                },
            };
        },
    ];
});
